export default "__VITE_ASSET__BrrpVDmG__"